
import WidgetNuxtWrapper from './widget-nuxt-wrapper';
import { mapGetters } from 'vuex';

const CACHE_LIST_VNODS = {}; // 缓存使用数据源的列表节点

export default {
  name: 'WidgetNuxt',
  components: {
    WidgetNuxtWrapper,
  },
  props: {
    widgetId: {
      type: String,
      default: '',
    },
    dataInject: {
      type: Object,
      default: () => ({}),
    },
    tree: {
      type: Object,
      default: () => ({}),
    },
    file: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function () {
    const { tree, dataInject, widgetId } = this;
    let node = tree[widgetId] ?? null;
    let templateId = '';
    let path = [];
    let count = -1;
    let cache = [];
    let idSuffix = Object.values(dataInject)
      .sort((a, b) => a.index - b.index)
      .map((o) => o.path);
    let idFull = widgetId + idSuffix.join('-');
    if (node) {
      const { dataSource, children } = node;
      if (dataSource?.i18n?.length && children?.length) {
        templateId = children[0];
        if (!tree[templateId]) templateId = '';
        path = this.$i18n.rp(dataSource, dataInject);
        count = this.getChildrenCount(node);
        if (dataSource && ~count) {
          if (!CACHE_LIST_VNODS[idFull]) {
            CACHE_LIST_VNODS[idFull] = [];
          }
          cache = CACHE_LIST_VNODS[idFull];
          if (cache.length > count) {
            CACHE_LIST_VNODS[idFull].length = count;
          }
        }
      }
    }
    return {
      branch: this.getBranch(count, templateId),
      node,
      templateId,
      path,
      count,
      cache,
      idSuffix,
      idFull,
      eventMap: [],
    };
  },
  computed: {
    ...mapGetters(['$bus']),
    widgetApi() {
      return {
        $bus: this.$bus,
      };
    },
  },
  mounted() {
    const { path } = this;
    if (!path.length) return;
    this.$bus.$on('rocket:system:after-update-locale', this.handleUpdateI18n);

    const pathNeedWatch = this.file.pathNeedWatch;
    if (!pathNeedWatch.length) return;
    let arr = [];
    for (let i = 0, l = path.length; i < l; i++) {
      arr.push(path[i]);
      let name = arr.join('.');
      if (pathNeedWatch.indexOf(name) > -1) {
        this.$bus.$on(
          'rocket:system:after-update-i18n:' + name,
          this.handleUpdateI18n
        );

        this.eventMap.push(['rocket:system:after-update-i18n:' + name]);
      }
    }
  },
  beforeDestroy() {
    const { idFull } = this;
    if (CACHE_LIST_VNODS[idFull]) {
      delete CACHE_LIST_VNODS[idFull];
    }
    if (this.eventMap.length) {
      this.eventMap.map((i) => {
        this.$bus.$off(i, this.handleUpdateI18n);
      });
    }
    this.$bus.$off('rocket:system:after-update-locale', this.handleUpdateI18n);
  },
  methods: {
    handleUpdateI18n() {
      let count = this.getChildrenCount(this.node);
      if (count !== this.count) {
        this.count = count;
        this.branch = this.getBranch(count, this.templateId);
      }
    },
    getChildrenCount(node) {
      let result = -1;
      let source = this.$i18n.r(node.dataSource, this.dataInject);

      if (Array.isArray(source)) {
        result = source.length;
        let page = ~~node.dataSource.page;
        let limit = ~~node.dataSource.limit;
        if (limit > 0) {
          let start = limit * page;
          result = Math.max(result - start, 0);
          if (result) {
            result = Math.min(result, limit);
          }
        }
      }
      return result;
    },
    getBranch(count, templateId) {
      const { tree, widgetId } = this;
      let node = tree[widgetId];
      if (!node) return {};

      let result = { ...tree };
      if (count < 1) {
        if (count === 0) {
          result[widgetId] = {
            ...node,
            children: [],
          };
          return result;
        }
        return tree;
      }
      let children = [];
      children.length = count;
      // console.log('templateId', templateId);
      children.fill(templateId);
      result[widgetId] = { ...node, children };
      // console.log('result', result[widgetId]);
      return result;
    },
    getCache() {
      return this.cache;
    },
    setCache(k, v) {
      return (this.cache[k] = v);
    },
  },
};
